import React, {Component} from 'react';
import {keys} from "../../Constants"
import './PainPointsTable.css'

class PainPointsTable extends Component {
    getFirstDescription(point, fieldName) {
        let values = point[fieldName];
        if (!values || values.length === 0) return "";
        return values[0][keys.description.value] || "";
    }

    renderPoint(point, type, protocolDescription) {
        let title = point[keys.name.value];
        let origin = point[keys.orig.value];
        let translation = point[keys.translation.value];
        let localization = point[keys.localization.value];
        let pointFunction = this.getFirstDescription(point, keys.function.value);
        let indication = this.getFirstDescription(point, keys.indication.value);
        let detail = protocolDescription || pointFunction || indication;

        return (
            <div className={"pain-point-chip pain-point-chip-" + type} key={point[keys.id.value]}>
                <div className="pain-point-chip-header">
                    <span className="pain-point-code">{title}</span>
                    <span className="pain-point-origin">{origin}</span>
                </div>
                {translation && <div className="pain-point-translation">{translation}</div>}
                {localization && <div className="pain-point-meta">{localization}</div>}
                {detail && <div className="pain-point-detail">{detail}</div>}
            </div>
        );
    }

    renderPointGroup(label, points, type) {
        if (!points || points.length === 0) return null;

        return (
            <div className="pain-point-group">
                <div className={"pain-point-group-title pain-point-group-title-" + type}>{label}</div>
                <div className="pain-point-chip-list">
                    {points.map(point => this.renderPoint(point, type))}
                </div>
            </div>
        );
    }

    renderCombinationGroup(label, groups, fallbackPoints, type) {
        if (!groups || groups.length === 0) {
            return this.renderPointGroup(label, fallbackPoints, type);
        }

        let singlePointGroups = groups.filter(group => group.points.length === 1);
        let combinationGroups = groups.filter(group => group.points.length > 1);

        return (
            <div className="pain-point-group">
                <div className={"pain-point-group-title pain-point-group-title-" + type}>{label}</div>
                {singlePointGroups.length > 0 &&
                    <div className="pain-point-chip-list">
                        {singlePointGroups.map(group => this.renderPoint(group.points[0], type, group.description))}
                    </div>
                }
                {combinationGroups.length > 0 &&
                    <div className="pain-combination-list">
                        {combinationGroups.map((group, index) => (
                            <div className={"pain-combination pain-combination-" + type} key={group.label + index}>
                                <div className="pain-combination-header">{group.label}</div>
                                {group.description && <div className="pain-combination-description">{group.description}</div>}
                                <div className="pain-point-chip-list pain-point-chip-list-compact">
                                    {group.points.map(point => this.renderPoint(point, type))}
                                </div>
                            </div>
                        ))}
                    </div>
                }
            </div>
        );
    }

    render() {
        return (
            <div className="pain-protocol-grid">
                {this.props.table.map(item => (
                    <div className="pain-protocol-card" key={item.name}>
                        <div className="pain-protocol-card-title">{item.name}</div>
                        <div className="pain-protocol-card-body">
                            {this.renderCombinationGroup(keys.mainPoints.label, item.mainPointGroups, item.mainPoints, "main")}
                            {this.renderCombinationGroup(keys.additionalPoints.label, item.additionalPointGroups, item.additionalPoints, "additional")}
                            {this.renderCombinationGroup(keys.electroPoints.label, item.electroPointGroups, item.electroPoints, "electro")}
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default PainPointsTable;
